module.exports = __webpack_public_path__ + "fonts/d63782f446a0cb341ae4ebf32c208343-Roboto-LightItalic.ttf";